import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FireFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.7948 1.31037C10.5631 1.21132 10.2971 1.23525 10.0868 1.37406C9.87654 1.51287 9.75 1.74802 9.75 2C9.75 4.10205 8.40595 5.66801 6.93056 7.38691C5.42224 9.14662 3.75 11.2053 3.75 14.5C3.75 19.0564 7.44365 22.75 12 22.75C16.5563 22.75 20.25 19.0564 20.25 14.5C20.25 13.4199 20.2373 11.221 18.0857 8.53148C17.8897 8.28651 17.5619 8.1894 17.2641 8.28806C16.9665 8.38667 16.7616 8.66025 16.7505 8.97358C16.7505 8.97358 16.7294 9.2141 16.7123 9.32533C16.6773 9.55281 16.615 9.8336 16.5096 10.0904C16.4015 10.3538 16.2727 10.5316 16.1409 10.6278C16.0375 10.7033 15.8806 10.7696 15.5797 10.7067C15.3223 10.6529 15.1924 10.5581 15.1092 10.4602C15.0146 10.349 14.9287 10.1718 14.8662 9.87923C14.8033 9.58501 14.7746 9.22724 14.7576 8.79103C14.7514 8.63338 14.7467 8.45574 14.7416 8.26878C14.7339 7.97843 14.7255 7.66558 14.7104 7.37031C14.6586 6.35823 14.519 5.18958 13.9583 4.0952C13.3854 2.97684 12.4064 1.99931 10.7948 1.31037ZM11.7472 10.9357C11.7271 10.7011 11.5978 10.4895 11.3982 10.3645C11.1987 10.2394 10.9519 10.2154 10.732 10.2995C9.77097 10.6673 9.03473 11.5513 8.55532 12.3973C8.07287 13.2487 7.75 14.2395 7.75 15C7.75 16.4021 8.19426 17.5923 8.97275 18.4399C9.7526 19.289 10.8302 19.7512 12 19.7512C14.5117 19.7512 16.25 17.2143 16.25 14.5012C16.25 14.2552 16.1294 14.0248 15.9272 13.8847C15.725 13.7446 15.467 13.7125 15.2367 13.7989C14.5388 14.0606 14.0163 14.0834 13.6285 13.9997C13.2453 13.917 12.9324 13.7174 12.6702 13.4258C12.1204 12.8144 11.8238 11.826 11.7472 10.9357Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FireFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FireFilledIcon;
